(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.meV830Ready === 'true') return;
    gallery.dataset.meV830Ready = 'true';

    const mainImage = gallery.querySelector('[data-me-pp-main-image], .me-pp-gallery__main-image');
    const stage = gallery.querySelector('[data-me-pp-stage]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-me-pp-thumb]'));
    const counter = gallery.querySelector('[data-me-pp-current-index]');
    const dialog = gallery.querySelector('[data-me-pp-zoom-dialog]');
    const zoomImage = gallery.querySelector('[data-me-pp-zoom-image]');
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let touchStartX = null;

    if (!mainImage) return;

    const setActive = (nextIndex, options = {}) => {
      if (!thumbs.length) return;
      activeIndex = (nextIndex + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      const src = thumb.dataset.src;
      const fullSrc = thumb.dataset.fullSrc || src;
      const alt = thumb.dataset.alt || '';

      mainImage.classList.add('is-changing');
      const preloader = new Image();
      preloader.onload = () => {
        mainImage.srcset = '';
        mainImage.src = src;
        mainImage.alt = alt;
        mainImage.dataset.fullSrc = fullSrc;
        requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
      };
      preloader.onerror = () => mainImage.classList.remove('is-changing');
      preloader.src = src;

      thumbs.forEach((item, index) => {
        const active = index === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(activeIndex + 1);
      if (zoomImage && dialog?.open) {
        zoomImage.src = fullSrc;
        zoomImage.alt = alt;
      }
      if (options.scrollThumb !== false) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setActive(index);
      }, true);
    });

    const previous = () => setActive(activeIndex - 1);
    const next = () => setActive(activeIndex + 1);
    gallery.querySelector('[data-me-pp-previous]')?.addEventListener('click', previous);
    gallery.querySelector('[data-me-pp-next]')?.addEventListener('click', next);
    gallery.querySelector('[data-me-pp-dialog-previous]')?.addEventListener('click', previous);
    gallery.querySelector('[data-me-pp-dialog-next]')?.addEventListener('click', next);

    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
      if (event.key === 'Enter' || event.key === ' ') {
        if (!event.target.closest('button')) { event.preventDefault(); gallery.querySelector('[data-me-pp-zoom-open]')?.click(); }
      }
    });

    const onTouchStart = (event) => { touchStartX = event.changedTouches?.[0]?.clientX ?? null; };
    const onTouchEnd = (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 45) return;
      delta > 0 ? previous() : next();
    };
    stage?.addEventListener('touchstart', onTouchStart, { passive: true });
    stage?.addEventListener('touchend', onTouchEnd, { passive: true });
    dialog?.addEventListener('touchstart', onTouchStart, { passive: true });
    dialog?.addEventListener('touchend', onTouchEnd, { passive: true });

    gallery.querySelector('[data-me-pp-zoom-open]')?.addEventListener('click', () => {
      if (zoomImage) {
        const activeThumb = thumbs[activeIndex];
        zoomImage.src = activeThumb?.dataset.fullSrc || mainImage.dataset.fullSrc || mainImage.currentSrc || mainImage.src;
        zoomImage.alt = mainImage.alt || '';
      }
      if (dialog && !dialog.open) dialog.showModal();
    });
    gallery.querySelector('[data-me-pp-zoom-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
    });

    window.addEventListener('me:product-media-changed', (event) => {
      const detail = event.detail || {};
      if (!detail.frontImage) return;
      const matchingIndex = thumbs.findIndex((thumb) => thumb.dataset.src === detail.frontImage || thumb.dataset.fullSrc === detail.frontImage);
      if (matchingIndex >= 0) setActive(matchingIndex);
    });
  };

  const init = (root = document) => root.querySelectorAll('[data-me-pp-gallery]').forEach(initGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
